import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import formatMoney from '../../utils/formatMoney';
import './styles.css';

const InvoiceItemsList = (props) => {
  const {
    amountDue,
    invoiceItems,
    remainingBalance,
    surchargeFee,
    surchargeLabel,
    createdDate,
    pastPayments,
  } = props;

  return (
    <>
      <List>
        <ListItem className="space-between">
          <div>
            <Typography className="subtitle-date" color="textSecondary">
              {format(new Date(createdDate), 'EEEE, MMMM dd, yyyy')}
            </Typography>
          </div>
          <div />
        </ListItem>
        {
          Object.entries(invoiceItems).map((entries) => {
            const itemName = entries[0];
            const itemAmount = entries[1];
            return (
              <ListItem key={`${itemName}-${itemAmount}`}>
                <div className="space-between">
                  <div>{itemName}</div>
                  <div>{formatMoney(itemAmount)}</div>
                </div>
              </ListItem>
            );
          })
        }
        <br />
        <ListItem>
          <div className="sub-total-list">
            <div><b>Total</b></div>
            <div>{formatMoney(amountDue)}</div>
          </div>
        </ListItem>
        <ListItem>
          <div className="surcharge-fee-list">
            <div><b>{surchargeLabel}</b></div>
            <div>{formatMoney(surchargeFee)}</div>
          </div>
        </ListItem>
        {
          pastPayments.map((item) => (
            <ListItem key={item.transaction_id} className="sub-total-list">
              <div>{`Payment on ${format(new Date(item.transaction_date), 'MMMM dd, yyyy')}`}</div>
              <div>{`-${formatMoney(item.transaction_amount)}`}</div>
            </ListItem>
          )).reverse()
        }
        <br />
        <ListItem>
          <div className="space-between">
            <div><b>Remaining Balance</b></div>
            <div><b>{formatMoney(remainingBalance)}</b></div>
          </div>
        </ListItem>
      </List>
    </>
  );
};

InvoiceItemsList.propTypes = {
  pastPayments: PropTypes.arrayOf(PropTypes.any).isRequired,
  createdDate: PropTypes.instanceOf(Date).isRequired,
  remainingBalance: PropTypes.string.isRequired,
  invoiceItems: PropTypes.objectOf(PropTypes.any).isRequired,
  amountDue: PropTypes.string.isRequired,
  surchargeFee: PropTypes.string.isRequired,
  surchargeLabel: PropTypes.string.isRequired,
};

export default InvoiceItemsList;
